import { Sort } from '@angular/material/sort';
import { IFetchEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/fetch-entity-failure-payload.interface';
import { IUpdateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/update-entity-failure-payload.interface';
import { ICreateGroupMemberActionPayload } from '../interfaces/create-group.action.payload.interface';
import { GroupMember } from '../models/group-member.model';

export interface IUpdateGroupMemberQuery {
    isAdmin: boolean;
    memberId: string;
}

export class SetGroupMember {
    static readonly type = '[GroupMember] SetGroupMember';

    constructor(public payload: GroupMember) {}
}

export class UnsetGroupMember {
    static readonly type = '[GroupMember] UnsetGroupMember';
}

export class FetchGroupMember {
    static readonly type = '[GroupMember] FetchGroupMember';

    constructor(public payload: string) {}
}

export class FetchGroupMemberSuccess {
    static readonly type = '[GroupMember] FetchGroupMemberSuccess';

    constructor(public payload: GroupMember) {}
}

export class FetchGroupMemberFailure {
    static readonly type = '[GroupMember] FetchGroupMemberFailure';

    constructor(public payload: IFetchEntityFailureActionPayload) {}
}

export class UpdateGroupMember {
    static readonly type = '[GroupMember] UpdateGroupMember';

    constructor(public payload: IUpdateGroupMemberQuery) {}
}

export class UpdateGroupMemberSuccess {
    static readonly type = '[GroupMember] UpdateGroupMemberSuccess';

    constructor(public payload: GroupMember) {}
}

export class UpdateGroupMemberFailure {
    static readonly type = '[GroupMember] UpdateGroupMemberFailure';

    constructor(public payload: IUpdateEntityFailureActionPayload) {}
}

export class CreateGroupMember {
    static readonly type = '[GroupMember] CreateGroupMember';

    constructor(public payload: ICreateGroupMemberActionPayload) {}
}

export class CreateGroupMemberSuccess {
    static readonly type = '[GroupMember] CreateGroupMemberSuccess';

    constructor(public payload: GroupMember[]) {}
}

export class CreateGroupMemberFailure {
    static readonly type = '[GroupMember] CreateGroupMemberFailure';
}

export class DeleteGroupMember {
    static readonly type = '[GroupMember] DeleteGroupMember';

    constructor(public payload: string) {}
}

export class DeleteGroupMemberSuccess {
    static readonly type = '[GroupMember] DeleteGroupMemberSuccess';

    constructor(public payload: string) {}
}

export class DeleteGroupMemberFailure {
    static readonly type = '[GroupMember] DeleteGroupMemberFailure';
}

export class ToggleSelectedGroupMember {
    static readonly type = '[GroupMember] ToggleSelectedGroupMember';

    constructor(public payload: string) {}
}

export class SelectFilteredGroupMembers {
    static readonly type = '[GroupMember] SelectFilteredGroupMembers';
}

export class DeselectSelectedGroupMembers {
    static readonly type = '[GroupMember] DeselectSelectedGroupMembers';
}

export class SearchGroupMembers {
    static readonly type = '[GroupMember] SearchGroupMembers';

    constructor(public payload: string) {}
}

export class SortGroupMembers {
    static readonly type = '[GroupMember] SortGroupMembers';

    constructor(public payload: Sort) {}
}

export class RefreshGroupMembersOnlineState {
    static readonly type = '[GroupMember] RefreshGroupMembersOnlineState';

    constructor(public payload?: GroupMember[]) {}
}
